/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Half_Bottle_375mlInputs */

const en_val_half_bottle_375ml = /** @type {(inputs: Val_Half_Bottle_375mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Half-Bottle (375ml)`)
};

const es_val_half_bottle_375ml = /** @type {(inputs: Val_Half_Bottle_375mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media botella (375ml)`)
};

const fr_val_half_bottle_375ml = /** @type {(inputs: Val_Half_Bottle_375mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demi-bouteille (375ml)`)
};

const de_val_half_bottle_375ml = /** @type {(inputs: Val_Half_Bottle_375mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halbe Flasche (375ml)`)
};

const ja_val_half_bottle_375ml = /** @type {(inputs: Val_Half_Bottle_375mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハーフボトル (375ml)`)
};

const zh_val_half_bottle_375ml = /** @type {(inputs: Val_Half_Bottle_375mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`半瓶装 (375ml)`)
};

const ar_val_half_bottle_375ml = /** @type {(inputs: Val_Half_Bottle_375mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نصف زجاجة (375 مل)`)
};

const id_val_half_bottle_375ml = /** @type {(inputs: Val_Half_Bottle_375mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setengah Botol (375ml)`)
};

const it_val_half_bottle_375ml = /** @type {(inputs: Val_Half_Bottle_375mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mezza Bottiglia (375ml)`)
};

const ru_val_half_bottle_375ml = /** @type {(inputs: Val_Half_Bottle_375mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Половинная (375мл)`)
};

const pt_val_half_bottle_375ml = /** @type {(inputs: Val_Half_Bottle_375mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meia Garrafa (375ml)`)
};

const ko_val_half_bottle_375ml = /** @type {(inputs: Val_Half_Bottle_375mlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`하프 보틀 (375ml)`)
};

/**
* | output |
* | --- |
* | "Half-Bottle (375ml)" |
*
* @param {Val_Half_Bottle_375mlInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_half_bottle_375ml = /** @type {((inputs?: Val_Half_Bottle_375mlInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Half_Bottle_375mlInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_half_bottle_375ml(inputs)
	if (locale === "es") return es_val_half_bottle_375ml(inputs)
	if (locale === "fr") return fr_val_half_bottle_375ml(inputs)
	if (locale === "de") return de_val_half_bottle_375ml(inputs)
	if (locale === "ja") return ja_val_half_bottle_375ml(inputs)
	if (locale === "zh") return zh_val_half_bottle_375ml(inputs)
	if (locale === "ar") return ar_val_half_bottle_375ml(inputs)
	if (locale === "id") return id_val_half_bottle_375ml(inputs)
	if (locale === "it") return it_val_half_bottle_375ml(inputs)
	if (locale === "ru") return ru_val_half_bottle_375ml(inputs)
	if (locale === "pt") return pt_val_half_bottle_375ml(inputs)
	return ko_val_half_bottle_375ml(inputs)
});